import React from 'react';

export const ErrorMessage = ({ children }: { children: JSX.Element | JSX.Element[] }): JSX.Element => (
  <article className="message is-warning">
    <div className="message-body">{children}</div>
  </article>
);
